export const ISA_ERROR = '@isa/ERROR';
export const ISA_TOKEN = '@isa/TOKEN';
export const ISA_USER = '@isa/USER';
export const ISA_TENANT_ID = '@isa/TENANT_ID';
export const ISA_THEME = '@isa/THEME';
export const ISA_LOCALE = '@isa/LOCALE';
export const ISA_CONFIGURATION = '@isa/CONFIGURATION';
export const ISA_USER_SELECTED_FOR_CONTEXT = '@isa/USER_SELECTED_FOR_CONTEXT';
export const ISA_ORIGINAL_USER_TOKEN = '@isa/ORIGINAL_USER_TOKEN';

export const THEMES = {
  DEFAULT: 'DEFAULT',
  DARK: 'DARK',
  LIGHT: 'LIGHT',
  BLUE: 'BLUE',
  GREEN: 'GREEN',
  INDIGO: 'INDIGO'
};

export const LOCALES = {
  ENGLISH: 'en-US',
  SPANISH: 'es-ES',
  PORTUGUESE: 'pt-BR'
};

export const CKEDITOR_LOCALES = {
  'es-ES': 'es',
  'en-US': 'en',
  'pt-BR': 'pt-br'
};

export const USER_ROLE = {
  VENDOR: 'vendor',
  MANAGER: 'manager',
  DIRECTOR: 'director',
  SUPERVISOR: 'supervisor',
  TECH: 'tech',
  TELEMARKETING: 'telemarketing',
  MAINTENANCE: 'maintenance'
};

export const INDICATOR_TYPE = {
  SALES: 'sales',
  PERCENTAGE_PROFIT: 'percentageProfit',
  VALUE_PROFIT: 'valueProfit',
  POSITIVATION: 'positivation',
  POSITIVATION_MIX: 'positiveMix'
};

export const REASON_TYPE = {
  CLIENTE_BLOCK: 'clientBlock',
  NON_PAYMENT: 'nonPayment',
  CREDIT_EXCEEDED: 'creditExceeded',
  BONIFICATION: 'bonification',
  NON_VISIT: 'nonVisit',
  NON_POSITIVATION: 'nonPositivation',
  NON_SALE: 'nonSale',
  VISIT_DATE: 'visitDate',
  SUBSIDIARY_BLOCKED: 'subsidiaryBlock',
  SALES_RESTRICTION: 'salesRestriction',
  CLIENT_REGULATION: 'clientRegulation',
  MAX_CREDIT_PERCENTAGE_EXCEEDED: 'maxCreditPercentageExceeded'
};

export const REASON_ACTIONS = {
  ALLOW: `allow`,
  DENY: `deny`,
  ANLY_CASH_ALLOWED: `anlyCashAllowed`
};

export const SALE_TYPE = {
  CASH: 'cash',
  FORWARD: 'forward'
};

export const SHIPPING_TYPE = {
  FREE: 'free',
  PAID: 'paid'
};

export const ORDER_TYPE = {
  NORMAL: 'normal',
  BONIFICATION: 'bonification',
  COLLECT: 'collect',
  FUTURE_SALE: 'futureSale',
  DELIVERY_PRE_ORDER: 'deliveryPreOrder',
  BONIFICATION_FREE_TAX: 'bonificationFreeTax',
  CONSIGNED_ORDER: 'consignedOrder',
  BUDGET_ERP: 'budgetERP',
  ASSISTED_SALE_TYPE: 'assistedSaleType',
  EXCHANGE: 'exchange',
  BASKET: 'basket'
};

export const STATUS_LOAD = {
  OPEN: 'open',
  CLOSED: 'closed',
  CANCEL: 'cancelled'
};

export const ROWS_ORIENTATION = {
  COLUMN: 'column',
  LIST: 'list',
  LISTWITHOUTIMAGE: 'listWithOutImage'
};

export const ROUTES_VALIDATIONS = {
  IS_LOGGED: 'isLogged',
  REQUESTED_ROLES: 'hasRequestedRole',
  LOAD_CONTROL: 'hasLoadControl',
  ALLOW_COSTUMER_REGISTRATION: 'hasAllowCustomerRegistration',
  USE_MANDATORY_MIX: 'hasUseMandatoryMix'
};

export const PROMOTION_LIST = {
  REGISTERED: 'registered',
  IMPORTED: 'imported'
};

export const CLIENT_LIST = {
  REGISTERED: 'registered',
  IMPORTED: 'imported'
};

export const ORDER_STATUS_ALL = [
  'accepted',
  'available',
  'billed',
  'budget',
  'blocked',
  'budgetERP',
  'canceled',
  'delivered',
  'error',
  'loaded',
  'mounted',
  'onDelivery',
  'paid',
  'partialBilled',
  'pending',
  'processing',
  'rejected',
  'released',
  'sincronized',
  'waitingERP',
  'waitingPayment',
  'partialReleased',
  'inPartialStock',
  'inStock',
  'waitingPartialBilling',
  'waitingBilling',
  'canceledItem',
  'canceledMinimumValue',
  'canceledSupervisor',
  'canceledWeb',
  'waitingApproval',
  'waitingLoad',
  'bonification',
  'canceledBudget',
  'returned'
];

export const INIDICATION_CLIENT = [
  {
    name: 'Positivação da Empresa',
    initials: 'P.E',
    color: 'primary',
    value: 'companyPositivity'
  },
  {
    name: 'Positivação do Vendedor',
    initials: 'P.V',
    color: 'success',
    value: 'sellerPositive'
  },
  {
    name: 'Títulos em aberto',
    initials: 'T.A',
    color: 'secondary',
    value: 'openBills'
  },
  {
    name: 'Bloqueado ERP',
    initials: 'B',
    color: 'error',
    value: 'blocked'
  }
];

export const TENANT_ID = {
  SELMI: ['60d9de212db79e65a42fa26f', '601bec060f02a380dbc9baa0']
};

export const CLIENT_ACTIONS_STATUS = {
  AVAILABLE: 'available',
  ERROR: 'error',
  PENDING: 'pending',
  PROCESSING: 'processing',
  REJECTED: 'rejected',
  WAITING_APPROVAL: 'waitingApproval'
};

export const CLIENT_ACTIONS_STATUS_LABEL = {
  [CLIENT_ACTIONS_STATUS.AVAILABLE]: 'Disponível',
  [CLIENT_ACTIONS_STATUS.ERROR]: 'Erro',
  [CLIENT_ACTIONS_STATUS.PENDING]: 'Pendente',
  [CLIENT_ACTIONS_STATUS.PROCESSING]: 'Processando',
  [CLIENT_ACTIONS_STATUS.REJECTED]: 'Rejeitado',
  [CLIENT_ACTIONS_STATUS.WAITING_APPROVAL]: 'Aguardando aprovação'
};

export const MARGIN_CONTROL_ACTIONS = [
  {
    value: 'allow',
    label: 'Permitir'
  },
  {
    value: 'deny',
    label: 'Negar'
  },
  {
    label: 'Aguardar Aprovação',
    value: 'waitingApproval'
  }
];

export const CLIENT_VISIT_FILTERS = [
  {
    value: 'withoutFilter',
    label: 'Todos'
  },
  {
    value: 'onlyHaveSale',
    label: 'Apenas com Venda'
  },
  {
    value: 'onlyHaveFeedback',
    label: 'Apenas com Feedback'
  }
];

export const ORDER_RECOVERY_KEY = '@ORDER_RECOVERY';

export const ERROR_ON_SEND_ORDER = {
  PDF: 'ERROR_SEND_PDF',
  ORDER: 'ERROR_SEND_ORDER'
};

export const CUSTOMIZABLE_CONTROL_CLIENT_REGISTER: {
  name: string;
  label?: string;
  type: 'string' | 'boolean' | 'number' | 'object' | 'array';
  key?: string;
  backendType: 'string' | 'boolean' | 'number' | 'array';
}[] = [
  { name: 'governmentalCode', label: 'CPF/CNPJ', type: 'string', backendType: 'string' },
  { name: 'clientName', label: 'Nome/Razão Social', type: 'string', backendType: 'string' },
  { name: 'name', label: 'Nome Fantasia/Apelido', type: 'string', backendType: 'string' },
  { name: 'stateRegistration', label: 'Inscrição Estadual', type: 'string', backendType: 'string' },
  { name: 'email', label: 'E-mail', type: 'string', backendType: 'string' },
  { name: 'invoiceEmail', label: 'E-mail NFE', type: 'string', backendType: 'string' },
  { name: 'billingEmail', label: 'E-mail de Cobrança', type: 'string', backendType: 'string' },
  { name: 'squareExternalCode', label: 'Praça', type: 'object', key: 'squareExternalCode', backendType: 'string' },
  {
    name: 'activityExternalCodes',
    label: 'Ramo de Atividade',
    type: 'array',
    key: 'activityExternalCodes',
    backendType: 'array'
  },
  {
    name: 'documents',
    label: 'Documentos',
    type: 'array',
    key: 'documents',
    backendType: 'array'
  },

  { name: 'observation', label: 'Observação', type: 'string', backendType: 'string' },
  { name: 'observation2', label: 'Observação 2', type: 'string', backendType: 'string' },
  { name: 'observation3', label: 'Observação 3', type: 'string', backendType: 'string' },
  { name: 'dayOfVisit', label: 'Dia da Visita', type: 'object', backendType: 'string' },
  {
    name: 'commercialInfoPostalCode',
    label: 'Informações Comerciais - CEP',
    type: 'string',
    key: 'commercialInfo.postalCode',
    backendType: 'string'
  },
  {
    name: 'commercialInfoAddress',
    label: 'Informações Comerciais - Endereço',
    type: 'string',
    key: 'commercialInfo.address',
    backendType: 'string'
  },
  {
    name: 'commercialInfoNumber',
    label: 'Informações Comerciais - Número',
    type: 'string',
    key: 'commercialInfo.number',
    backendType: 'string'
  },
  {
    name: 'commercialInfoDistrict',
    label: 'Informações Comerciais - Bairro',
    type: 'string',
    key: 'commercialInfo.district',
    backendType: 'string'
  },
  {
    name: 'commercialInfoCity',
    label: 'Informações Comerciais - Cidade',
    type: 'string',
    key: 'commercialInfo.city',
    backendType: 'string'
  },
  {
    name: 'commercialInfoState',
    label: 'Informações Comerciais - Estado',
    type: 'string',
    key: 'commercialInfo.state',
    backendType: 'string'
  },
  {
    name: 'commercialInfoPhoneNumber',
    label: 'Informações Comerciais - Telefone',
    type: 'string',
    key: 'commercialInfo.phoneNumber',
    backendType: 'string'
  },
  {
    name: 'commercialInfoCellphoneNumber',
    label: 'Informações Comerciais -  Celular',
    type: 'string',
    key: 'commercialInfo.cellphoneNumber',
    backendType: 'string'
  },
  {
    name: 'deliveryInfoPostalCode',
    label: 'Informações de Entrega - CEP',
    type: 'string',
    key: 'deliveryInfo.postalCode',
    backendType: 'string'
  },
  {
    name: 'deliveryInfoAddress',
    label: 'Informações de Entrega - Endereço',
    type: 'string',
    key: 'deliveryInfo.address',
    backendType: 'string'
  },
  {
    name: 'deliveryInfoNumber',
    label: 'Informações de Entrega - Número',
    type: 'string',
    key: 'deliveryInfo.number',
    backendType: 'string'
  },
  {
    name: 'deliveryInfoDistrict',
    label: 'Informações de Entrega - Bairro',
    type: 'string',
    key: 'deliveryInfo.district',
    backendType: 'string'
  },
  {
    name: 'deliveryInfoCity',
    label: 'Informações de Entrega - Cidade',
    type: 'string',
    key: 'deliveryInfo.city',
    backendType: 'string'
  },
  {
    name: 'deliveryInfoState',
    label: 'Informações de Entrega - Estado',
    type: 'string',
    key: 'deliveryInfo.state',
    backendType: 'string'
  },
  {
    name: 'deliveryInfoPhoneNumber',
    label: 'Informações de Entrega - Celular',
    type: 'string',
    key: 'deliveryInfo.phoneNumber',
    backendType: 'string'
  },
  {
    name: 'billingInfoPostalCode',
    label: 'Informações de Cobrança - CEP',
    type: 'string',
    key: 'billingInfo.postalCode',
    backendType: 'string'
  },
  {
    name: 'billingInfoAddress',
    label: 'Informações de Cobrança - Endereço',
    type: 'string',
    key: 'billingInfo.address',
    backendType: 'string'
  },
  {
    name: 'billingInfoNumber',
    label: 'Informações de Cobrança - Número',
    type: 'string',
    key: 'billingInfo.number',
    backendType: 'string'
  },
  {
    name: 'billingInfoDistrict',
    label: 'Informações de Cobrança - Bairro',
    type: 'string',
    key: 'billingInfo.district',
    backendType: 'string'
  },
  {
    name: 'billingInfoCity',
    label: 'Informações de Cobrança - Cidade',
    type: 'string',
    key: 'billingInfo.city',
    backendType: 'string'
  },
  {
    name: 'billingInfoState',
    label: 'Informações de Cobrança - Estado',
    type: 'string',
    key: 'billingInfo.state',
    backendType: 'string'
  },
  {
    name: 'billingInfoPhoneNumber',
    label: 'Informações de Cobrança - Celular',
    type: 'string',
    key: 'billingInfo.phoneNumber',
    backendType: 'string'
  },
  { name: 'buyerName', label: 'Informações de Viabilidade - Nome do Comprador', type: 'string', backendType: 'string' },
  {
    name: 'buyerContact',
    label: 'Informações de Viabilidade - Contato do Comprador',
    type: 'string',
    backendType: 'string'
  },
  {
    name: 'deadlineSuggestion',
    label: 'Informações de Viabilidade - Sugestão de Prazo',
    type: 'object',
    backendType: 'string'
  },
  {
    name: 'creditLimitSuggestion',
    label: 'Informações de Viabilidade - Sugestão de Limite de Crédito',
    type: 'string',
    backendType: 'number'
  }
];

export const DAYS_OF_WEEK = [
  {
    value: '1',
    label: 'Domingo'
  },
  {
    value: '2',
    label: 'Segunda-feira'
  },
  {
    value: '3',
    label: 'Terça-feira'
  },
  {
    value: '4',
    label: 'Quarta-feira'
  },
  {
    value: '5',
    label: 'Quinta-feira'
  },
  {
    value: '6',
    label: 'Sexta-feira'
  },
  {
    value: '7',
    label: 'Sábado'
  }
];

export const PAYMENT_OPTION_TYPE = {
  PIX: 'PIX'
};

export const BRAZILIAN_STATES = [
  { externalCode: 'AC', name: 'Acre' },
  { externalCode: 'AL', name: 'Alagoas' },
  { externalCode: 'AP', name: 'Amapá' },
  { externalCode: 'AM', name: 'Amazonas' },
  { externalCode: 'BA', name: 'Bahia' },
  { externalCode: 'CE', name: 'Ceará' },
  { externalCode: 'DF', name: 'Distrito Federal' },
  { externalCode: 'ES', name: 'Espírito Santo' },
  { externalCode: 'GO', name: 'Goiás' },
  { externalCode: 'MA', name: 'Maranhão' },
  { externalCode: 'MT', name: 'Mato Grosso' },
  { externalCode: 'MS', name: 'Mato Grosso do Sul' },
  { externalCode: 'MG', name: 'Minas Gerais' },
  { externalCode: 'PA', name: 'Pará' },
  { externalCode: 'PB', name: 'Paraíba' },
  { externalCode: 'PR', name: 'Paraná' },
  { externalCode: 'PE', name: 'Pernambuco' },
  { externalCode: 'PI', name: 'Piauí' },
  { externalCode: 'RJ', name: 'Rio de Janeiro' },
  { externalCode: 'RN', name: 'Rio Grande do Norte' },
  { externalCode: 'RS', name: 'Rio Grande do Sul' },
  { externalCode: 'RO', name: 'Rondônia' },
  { externalCode: 'RR', name: 'Roraima' },
  { externalCode: 'SC', name: 'Santa Catarina' },
  { externalCode: 'SP', name: 'São Paulo' },
  { externalCode: 'SE', name: 'Sergipe' },
  { externalCode: 'TO', name: 'Tocantins' }
];

export const ASYNC_CONFIG = {
  HAVE_STOCK: '@asyncConfig/HAVE_STOCK'
};
